import {Colors} from "../../colors";
import {MenuPlatform} from "./types";

export const getMenuPlatformColors = (platform: MenuPlatform) => {
  switch (platform) {
    case "spring":
      return {
        accent: Colors.primary._800,
        selectedBackground: Colors.primary._100,
        hoverBackground: Colors.primary._100,
        logoColor: Colors.primary._200,
      };
    case "reach":
      return {
        accent: Colors.blue._800,
        selectedBackground: Colors.blue._100,
        hoverBackground: Colors.blue._100,
        logoColor: Colors.blue._200,
      };
    case "partner":
    default:
      return {
        accent: Colors.secondary._800,
        selectedBackground: Colors.secondary._100,
        hoverBackground: Colors.secondary._100,
        logoColor: Colors.secondary._200,
      };
  }
};
